import React, { useState, useEffect } from "react";
import AVReactPlayer from "./AVReactPlayer";
import styled from "styled-components";
import Switch from "react-switch";
import { ReactSortable } from "react-sortablejs";
import { toast, ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgressBar from "./CircularProgressBar";

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const Card = styled.div`
    position: relative;
    width: 200px;
    height: 250px;
    margin: 5px;
    display: inline-block;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 5px;
    padding-top: 30px;
    transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out,
        background-color 0.3s ease-in-out;
    border-radius: 5%;
    border: 1px solid #333;
    user-select: none;
    font-size: 1em;

    @media (max-width: 768px) {
        width: 200px;
        height: 250px;
        font-size: 0.9em;
    }

    @media (max-width: 480px) {
        width: 90px;
        height: 140px;
        font-size: 0.8em;
    }
`;

const Badge = styled.div`
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: red;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    color: white;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
`;

const CardsMerger = (props) => {
    const {
        titleDownload,
        titleDelete,
        titleReady,
        titleCancel,
        titleMerge,
        tip1,
        tip2,
        sessionId,
    } = props.attributes;

    const [cards, setCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showCards, setShowCards] = useState(true);
    const [switchValue1, setSwitchValue1] = useState(false);

    const [isFileDownloading, setIsFileDownloading] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);

    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setCards(
            props.filesList.map((file, index) => ({
                order: index + 1,
                fileId: file.fileId,
                fileName: file.fileName,
            }))
        );
    }, [props.filesList]);

    useEffect(() => {
        window.Echo.channel(`video-progress.${sessionId}`).listen(
            "VideoMergeProgress",
            (e) => {
                setProgress(e.progress);
            }
        );
    }, [sessionId]);

    const handleMerge = () => {
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowCards(false);

        const requestBody = {
            cards: cards,
            switchValue1: switchValue1,
        };

        const timestamp = Date.now();

        fetch(`/api/mergeVideo?timestamp=${timestamp}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => {
                if (!response.ok) {
                    return response.json().then((error) => {
                        if (response.status === 470) {
                            console.log(error);
                            // Обновить состояние файлов
                            props.setFilesList((prevFiles) =>
                                prevFiles.filter(
                                    (file) => file.fileId !== error.fileId
                                )
                            );
                        }
                        throw new Error(error.message || "Error fetching data");
                    });
                }
                return response.json();
            })
            .then((responseData) => {
                console.log(responseData);
                setIsProcessingFinished(true);
                setDownloadUrl(responseData.url);
                setIsLoading(false);
                setIsDownloading(false);
                props.setShowUploader(false);
                document.body.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
                setProgress(0);
            })
            .catch((error) => {
                toast.error(error.message || "Error fetching data", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Bounce,
                });
                setIsLoading(false);
                setShowCards(true);
            });
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowCards(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const handleChangeSwitch1 = () => {
        setSwitchValue1(!switchValue1);
        console.log(switchValue1);
    };

    useEffect(() => {
        const newCards = props.filesList.map((file, index) => ({
            order: index + 1,
            fileId: file.fileId,
            fileName: file.fileName,
        }));
        setCards(newCards);

        if (newCards.length === 0) {
            setShowCards(false);
        } else {
            setShowCards(true);
        }
    }, [props.filesList]);

    const reloadPage = () => {
        setShowCards(true);
        location.reload();
    };

    function downloadFile(url) {
        setIsFileDownloading(true);
        setDownloadProgress(0);

        fetch(url)
            .then((response) => {
                const contentLength = response.headers.get("content-length");
                if (!contentLength) {
                    throw new Error(
                        "Content-Length response header is missing"
                    );
                }
                const total = parseInt(contentLength, 10);
                let loaded = 0;
                let lastProgress = 0;
                const reader = response.body.getReader();
                const chunks = [];

                function read() {
                    reader
                        .read()
                        .then(({ done, value }) => {
                            if (done) {
                                const blob = new Blob(chunks);
                                const downloadUrl =
                                    window.URL.createObjectURL(blob);
                                const link = document.createElement("a");
                                link.href = downloadUrl;
                                link.setAttribute("download", getFileName(url));
                                document.body.appendChild(link);
                                link.click();
                                link.parentNode.removeChild(link);
                                window.URL.revokeObjectURL(downloadUrl);
                                setIsFileDownloading(false);
                                setIsDownloading(true);
                                return;
                            }

                            chunks.push(value);
                            loaded += value.byteLength;

                            // Обновляем прогресс скачивания каждые 5%
                            const currentProgress = Math.floor(
                                (loaded / total) * 100
                            );
                            if (currentProgress >= lastProgress + 5) {
                                lastProgress = currentProgress;
                                setDownloadProgress(currentProgress);
                            }

                            read();
                        })
                        .catch((error) => {
                            console.error("Download error:", error);
                            setIsFileDownloading(false);
                        });
                }

                read();
            })
            .catch((err) => {
                console.error("Error downloading file:", err);
                setIsFileDownloading(false);
            });
    }

    return (
        <div>
            <Container>
                {showCards && (
                    <>
                        <span
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "20px",
                                backgroundColor: "lightblue",
                                color: "darkblue",
                                fontSize: "1.0em",
                                borderRadius: "4px",
                                marginBottom: "20px",
                            }}
                        >
                            {tip1}
                        </span>
                        <ReactSortable
                            list={cards}
                            setList={(newState) => {
                                setCards(
                                    newState.map((card, index) => ({
                                        ...card,
                                        order: index + 1,
                                    }))
                                );
                            }}
                            animation={200}
                        >
                            {cards.map((card, i) => (
                                <Card key={i}>
                                    <Badge>{card.order}</Badge>
                                    <div style={{ marginBottom: "20px" }}>
                                        {card.fileName}
                                    </div>
                                    <img
                                        src={"/img/video-player.svg"}
                                        alt={card.content}
                                        style={{ width: "100%" }}
                                    />
                                </Card>
                            ))}
                        </ReactSortable>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "1em",
                            }}
                        >
                            <Switch
                                onChange={handleChangeSwitch1}
                                checked={switchValue1}
                            />
                            <span
                                style={{
                                    marginLeft: "10px",
                                    padding: "10px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                }}
                            >
                                {tip2}
                            </span>
                        </div>
                        <div className="px-4 py-2">
                            <ButtonContainer>
                                <StyledButton onClick={handleMerge}>
                                    {titleMerge}
                                </StyledButton>
                            </ButtonContainer>
                        </div>
                    </>
                )}
                {errorMessage && (
                    <div>
                        <div className="px-4 py-2">
                            <div
                                className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                                role="alert"
                            >
                                {errorMessage}
                            </div>
                        </div>
                        <div className="px-4 py-2">
                            <ButtonContainer>
                                <StyledButton onClick={reloadPage}>
                                    {titleCancel}
                                </StyledButton>
                            </ButtonContainer>
                        </div>
                    </div>
                )}
                {isLoading && (
                    <LoaderContainer>
                        <CircularProgressBar value={progress} />
                    </LoaderContainer>
                )}
                {isProcessingFinished && !isDownloading && (
                    <div>
                        <StyledMessage>{titleReady}</StyledMessage>
                        <div className="px-4 py-2">
                            <AVReactPlayer videoUrl={downloadUrl} />
                        </div>
                        {isFileDownloading ? (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "auto",
                                }}
                            >
                                <CircularProgressBar
                                    value={Math.round(downloadProgress)}
                                />
                            </div>
                        ) : (
                            <ButtonContainer>
                                <a
                                    href={downloadUrl}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadFile(downloadUrl);
                                    }}
                                >
                                    <StyledButton>{titleDownload}</StyledButton>
                                </a>
                                <a className="pl-2" onClick={handleDownload}>
                                    <StyledButtonDelete>
                                        {titleDelete}
                                    </StyledButtonDelete>
                                </a>
                            </ButtonContainer>
                        )}
                    </div>
                )}
                {isDownloading && (
                    <div>
                        <ButtonContainer>
                            <StyledButton onClick={resetDownload}>
                                {titleCancel}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                )}
            </Container>
            <ToastContainer style={{ zIndex: 10000 }} />
        </div>
    );
};

export default CardsMerger;
